import DashboardLayout from "layout/DashboardLayout/DashboardLayout";
import React from "react";

export default function SettingsPage() {
  return <DashboardLayout>This is Settings Page</DashboardLayout>;
}
